import React from 'react';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  Divider,
  Typography,
  Stack,
} from '@mui/material';

import type { PageType, CategoryType } from '@/domain/ui/redux';
import type { IconNames } from '@/types/common/icon';

import { postGroups } from '@/containers/const';

/**
 * Postタイプ
 */
export type PostType = {
  /** 画像 */
  image: string,
  /** タイトル */
  title: string,
  /** キー */
  key: PageType,
  /** カテゴリ */
  category: CategoryType,
  /** アイコン */
  icon: IconNames,
  /** 注文 */
  order: number,
};

/** プロパティ */
export type Props = {
  /** ポストリスト */
  posts: PostType[],
  /** クリック */
  onClick: (post: PostType) => void,
};

const TopMenu: React.FC<Props> = ({ posts, onClick }) => {
  const postsOrder = posts.sort((a, b) => a.order - b.order);
  const groups = postGroups.map((v) => {
    const items = postsOrder.filter((post) => post.category === v.key);
    if (items.length === 0) {
      return null;
    }
    return (
      <div key={v.key} style={{ marginTop: '10px' }}>
        <div style={{ padding: '10px' }}>
          <Stack direction="row" alignItems="center" gap={1}>
            <ArrowRightIcon />
            <Typography variant="body1">{v.title}</Typography>
          </Stack>
        </div>
        <Divider />
        <Grid container spacing={1}>
          {items.map((post) => (
            <Grid item key={post.title} xs={4} md={3} lg={2}>
              <Card onClick={() => onClick(post)}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt={`${post.title}へ移動する`}
                    image={post.image}
                    title={`${post.title}へ移動する`}
                    sx={{ width: '80%', margin: '10% auto 0' }}
                  />
                  <p style={{ textAlign: 'center' }}>{post.title}</p>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  });
  return (
    <div>
      {groups}
    </div>
  );
};

export default TopMenu;
